import React, { Component, useState, useEffect } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import StandardList from '../common/listing/list.component.jsx'
import DebounceInput from "react-debounce-input";
import Icon from "../common/icon/icon.component.jsx";
import Pagination from '../common/listing/pagination.component.jsx'
import SortLink from "../common/listing/sortlink.component.jsx";
import { Link } from 'react-router-dom'
import ActionButton from "../common/button/actionbutton.component.jsx";
import LabelSelect from '../common/label/selection.component.jsx'
import ProgressBar from "../common/progress-bar/progressbar.component.jsx";
import {INTEGRATION_KEY} from "../state/integration/Constants";

const messages = defineMessages({
    "search_placeholder": {
        id: 'order.lines.listing.search_placeholder',
        defaultMessage: 'Search order lines...',
    },
    "label_filter_placeholder": {
        id: 'order.lines.listing.search_vendor_label_placeholder',
        defaultMessage: 'Filter by vendor',
    },
})
class PurchaseOrderLinesToAddListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            headers: [],
            rows: [],
            footer: [],
            searchKeywords: '',
            activePage: 1,
            pageSize: 5,
            totalItemsCount: 0,
            sortField: 'productTitleSort',
            asc: true,
            loading: false,

            purchaseOrderExternalId: this.props.purchaseOrderExternalId || '',
            submitButtonLoading: false,
            vendorSearchId: null,

            addingMultipleOrderLines: false,
            currentOrderLineBeingProcessed: null,
            currentRequestIndex: 0,
            totalNumberOfRequestsToExecute: 0,
            selectAllPageSize: 0,
        }

        this.handlePageChange = this.handlePageChange.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleSortLinkChange = this.handleSortLinkChange.bind(this)
        this.onLabelSelectChange = this.onLabelSelectChange.bind(this)

        this.addOrderLineToPurchaseOrder = this.addOrderLineToPurchaseOrder.bind(this)
        this.addMultipleOrderLinesToPurchaseOrder = this.addMultipleOrderLinesToPurchaseOrder.bind(this)
        this.onRowsRemoved = this.props.onRowsRemoved
    }

    componentDidMount() {
        this.refreshSearch(true)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            purchaseOrderExternalId: nextProps.purchaseOrderExternalId || '',
            addedRows: nextProps.addedRows,
        }, () => {
            if (this.state.addedRows.length > 0) {
                let addedRows = []
                for (let row of this.state.addedRows) {
                    row.data[0] = <ActionButton
                        type="button"
                        className="btn btn-sm btn-primary"
                        isLoading={this.state.submitButtonLoading}
                        onClick={e => this.addOrderLineToPurchaseOrder(e, [row.row])}
                    >
                        <Icon className="" value={'plus'} />
                    </ActionButton>
                    addedRows.push(row)
                }

                const newRows = addedRows.concat(this.state.rows)
                const newTotalItemsCount = this.state.totalItemsCount + addedRows.length
                this.setState({
                    rows: newRows,
                    totalItemsCount: newTotalItemsCount,
                    addedRows: [],
                    headers: this.headers(),
                }, () => {
                    this.setState({
                        pageSize: this.state.rows.length,
                        footer: this.footer()
                    })
                })
            }
        })
    }

    getDefaultFilters() {
        let filters = {
            orderStatus: "ordered",
            inventoryRequestedMeasure: ">;0",
            "externalPurchaseOrder.externalId": "",
            "{oneOf}": [
                {"isNonInventory": false},
                {"isNonInventory": "{!exists};"},
            ],
        }
        if (this.state.vendorSearchId) {
            filters["defaultVendorLabelId"] = this.state.vendorSearchId
        }
        return filters
    }

    getSearchPostData() {
        let filters = this.getDefaultFilters()
        let objects = ['order-lines']

        return {
            keywords: GlobalHelper.formatSearchKeywords(this.state.searchKeywords),
            objects: objects,
            fields: [
                'productTitle',
                'productTitleKeyword',
                'productTitleAnalyzed',

                'orderIdentifier',
                'orderIdentifierAnalyzed',
                'orderIdentifierNumber',
                'orderIdentifierKeyword',

                'poNumber',
                'poNumberAnalyzed',
                'poNumberKeyword',

                'contact.name',
                'contact.nameAnalyzed',
                'contact.nameKeyword',
                'contact.organizationNameKeyword',
                'contact.organizationNameAnalyzed',

                'defaultVendor',
                'defaultVendorKeyword',
                'defaultVendorAnalyzed',
                'locationName',
            ],
            totals: [
                'baseCurrencyTotalAmount',
            ],
            pageSize: this.state.selectAllPageSize || this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: this.state.sortField,
            sortAsc: this.state.asc,
            filters: filters,
            lightResult: true,
        }
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size
        }, () => {
            this.refreshSearch(false)
        })
    }

    getNewPageSizeOnPageChange() {
        if (this.state.pageSize < 10) {
            return 5
        } else if (this.state.pageSize < 25) {
            return 10
        } else if (this.state.pageSize < 50) {
            return 25
        } else {
            return 50
        }
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber,
            pageSize: this.getNewPageSizeOnPageChange(),
        }, () => {
            this.refreshSearch(false)
        })
    }

    handleSortLinkChange(sortField, asc) {
        this.setState({
            sortField: sortField,
            asc: asc,
        }, () => {
            this.refreshSearch(false)
        })
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value,
            activePage: 1,
        }, () => {
            this.refreshSearch(true)
        })
    }

    onLabelSelectChange(labelIds) {
        this.setState({
            vendorSearchId: labelIds,
            activePage: 1,
        }, () => {
            this.refreshSearch(true)
        })
    }

    refreshSearch(refreshTotal) {
        this.setState({
            loading: true,
        })
        const data = this.getSearchPostData(false)
        Promise.all([
            AppContext.getApiClient().post('/listing/search', data),
        ]).then(res => {
            const r = res[0]
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q, false)),
                totalItemsCount: r.metadata.totalItemsCount,
                loading: false,
            })
        })
        if (refreshTotal) {
            AppContext.getApiClient().post('/listing/search-totals', data).then(res => {
                this.setState({
                    totalItemsCount: res.attributes.totalItemsCount,
                }, () => {
                    this.setState({
                        footer: this.footer()
                    })
                })
            })
        }
    }

    headers() {
        let headers = [
            '',
            <FormattedMessage
                id="purchase_order_lines.listing.headers.product_external_id_label"
                defaultMessage="ID"
            />,
            <SortLink
                field={'productTitleSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="purchase_order_lines.listing.headers.product_label"
                    defaultMessage="Product name"
                />
            </SortLink>,
            <SortLink
                field={'defaultVendor'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="purchase_order_lines.listing.headers.default_vendor_label"
                    defaultMessage="Default vendor"
                />
            </SortLink>,
            <SortLink
                field={'orderIdentifier'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="purchase_order_lines.listing.headers.order_id_label"
                    defaultMessage="Order ID"
                />
            </SortLink>,
        ]
        let classNames = ['']

        headers = headers.concat([
            <SortLink
                field={'contact.nameSort'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="purchase_order_lines.listing.contact_label"
                    defaultMessage="Contact"
                />
            </SortLink>,
        ])

        headers.push(<SortLink
            field={'locationNameSort'}
            sortField={this.state.sortField}
            asc={this.state.asc}
            onChange={this.handleSortLinkChange}
        >
            <FormattedMessage
                id="purchase_order_lines.listing.location_label"
                defaultMessage="Location"
            />
        </SortLink>)
        classNames.push('')

        classNames = classNames.concat(['', '', '', ''])
        return {
            classNames: classNames,
            data: headers,
        }
    }

    addOrderLineToPurchaseOrder(e, rows) {
        if (e) {
            e.preventDefault()
        }

        this.setState({
            submitButtonLoading: true,
            loading: true,
        })

        const data = {
            rows:
                rows.map(r => {
                    return {
                        referenceRowId: r.id,
                        orderId: r.orderId,
                    }
                }),
            integrationKey: INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            externalPurchaseOrderId: this.state.purchaseOrderExternalId,
        }
        AppContext.getApiClient().post(`/orders/external-purchase-orders/${this.state.purchaseOrderExternalId}/order-lines`, data).then(res => {
            this.setState({
                submitButtonLoading: false,
            }, () => {
                if (!res.error) {
                    this.addOrderLines(this.getStateRowsIndexes(rows))
                } else {
                    this.setState({ loading: false })
                }
            })
        })
    }

    async addMultipleOrderLinesToPurchaseOrder(rows) {
        this.setState({
            addingMultipleOrderLines: true,
            currentRequestIndex: 1,
            totalNumberOfRequestsToExecute: rows.length
        })

        for (let i = 0; i < rows.length; i++) {
            this.setState({
                currentOrderLineBeingProcessed: rows[i],
                currentRequestIndex: i + 1,
            })

            const data = {
                rows:
                    [
                        {
                            referenceRowId: rows[i].id,
                            orderId: rows[i].orderId,
                        },
                    ],
                integrationKey: INTEGRATION_KEY.LIGHTSPEED_RETAIL,
                externalPurchaseOrderId: this.state.purchaseOrderExternalId,
            }

            await AppContext.getApiClient().post(`/orders/external-purchase-orders/${this.state.purchaseOrderExternalId}/order-lines`, data)
        }

        this.setState({
            addingMultipleOrderLines: false,
            currentRequestIndex: 0,
            currentOrderLineBeingProcessed: null,
        }, () => {
            this.addOrderLines(this.getStateRowsIndexes(rows))
        })
    }

    getStateRowsIndexes(rows) {
        const rowIds = rows.map(r => r.id)
        const indexes = this.state.rows.map((r, index) => {
            if (rowIds.includes(r.rowId)) {
                return index
            }
            return -1
        })
        return indexes
    }

    addOrderLines(indexes) {
        let addedRows = []
        for (let index of indexes) {
            if (index === -1) {
                continue
            }
            addedRows.push(this.state.rows[index])
        }

        const newTotalItemsCount = this.state.totalItemsCount - addedRows.length
        this.setState({
            rows: this.state.rows.map(r => {
                r.selected = false
                return r
            }).filter((r, i) => {
                return !indexes.includes(i)
            }),
            totalItemsCount: newTotalItemsCount,
            selectAllPageSize: 0,
        }, () => {
            this.setState({
                pageSize: this.state.rows.length,
                footer: this.footer(),
                loading: false,
            })
            this.onRowsRemoved(addedRows)
        })
    }

    row(orderLine) {
        let rows = []

        let lightspeedLink = null
        if (orderLine.uniqueExternalId && orderLine.uniqueExternalId.length > 0) {
            lightspeedLink = orderLine.uniqueExternalId.find(l => l.split('_')[0] === INTEGRATION_KEY.LIGHTSPEED_RETAIL)
        }
        const externalId = lightspeedLink ? lightspeedLink.split('_')[1] : ''

        if (externalId) {
            rows.push(<ActionButton
                type="button"
                className="btn btn-sm btn-primary"
                isLoading={this.state.submitButtonLoading}
                onClick={e => this.addOrderLineToPurchaseOrder(e, [orderLine])}
            >
                <Icon className="" value={'plus'} />
            </ActionButton>)
        } else {
            rows.push('')
        }

        rows = rows.concat([
            <span>{externalId || '-'}</span>,
            <span>{orderLine.productTitle}</span>,
            <span>
                {orderLine.defaultVendor || '-'}
            </span>,
            <div>
                <div>
                    <Link to={'/orders/' + orderLine.orderId + '/edit'} target="_blank" rel='noopener noreferrer'>
                        {orderLine.orderIdentifier}
                    </Link>
                    <small className="ml-2">{orderLine.poNumber}</small>
                </div>
                <div>
                    <small>
                        <FormattedMessage
                            id="purchase_order_lines.listing.quantity"
                            defaultMessage="Quantity"
                        />: {orderLine.inventoryRequestedMeasure}
                    </small>
                </div>
            </div>
        ])

        const customer = orderLine.contact || {}
        const contact = []
        contact.push(<Link key={contact.length} to={'/contacts/' + orderLine.contactId + '/details'} target="_blank" rel='noopener noreferrer'>
            {orderLine.contact ? orderLine.contact.name : '-'}
        </Link>)
        if (customer.organizationId && customer.type === 'persons') {
            contact.push(<Link className={'ml-1'} key={contact.length} to={'/contacts/' + customer.organizationId + '/details'} target="_blank" rel='noopener noreferrer'>
                <small><Icon value={'building'} />{customer.organizationName}</small>
            </Link>)
        }

        rows = rows.concat([
            contact,
            <span>
                {orderLine.locationName ? orderLine.locationName : '-'}
            </span>
        ])

        return {
            classNames: ['', '', '', '', '', '', ''],
            row: orderLine,
            rowId: orderLine.id,
            data: rows,
            unselectable: !externalId,
            selected: externalId && this.state.selectAllPageSize > 0,
        }
    }

    footer() {
        let rows = [
            <strong>
                <span className="mr-1">{this.state.totalItemsCount}</span>
                <FormattedMessage
                    id="purchase_order_lines.listing.headers.results_label"
                    defaultMessage="items"
                />
            </strong>,
        ]

        rows = rows.concat([
            '',
            '',
            '',
            '',
            '',
            '',
            '',
        ])
        return {
            classNames: ['pl-4', '', '', '', '', '', ''],
            data: rows,
        }
    }

    renderProgressBarModalStatus() {
        return <div className="d-flex align-items-center justify-content-center position-fixed w-100 h-100" style={{ zIndex: 99999, left: 0, top: 0 }}>
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header text-center">
                        <div className="h5 modal-title w-100">
                            <p>
                                <FormattedMessage
                                    id="purchase_order_lines.mutliple_add_modal.in_progress"
                                    defaultMessage="Adding {quantity} of {productTitle} from {identifier}"
                                    values={{
                                        quantity: this.state.currentOrderLineBeingProcessed.inventoryRequestedMeasure,
                                        productTitle: this.state.currentOrderLineBeingProcessed.productTitle,
                                        identifier: this.state.currentOrderLineBeingProcessed.orderIdentifier,
                                    }}
                                />
                            </p>
                            <p>
                                {this.state.currentRequestIndex}/{this.state.totalNumberOfRequestsToExecute}
                            </p>
                            {
                                this.state.totalNumberOfRequestsToExecute > 0 &&
                                <ProgressBar progress={this.state.currentRequestIndex / this.state.totalNumberOfRequestsToExecute * 100} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {

        return (
            [
                this.state.addingMultipleOrderLines ?
                    this.renderProgressBarModalStatus() : '',
                this.state.loading ? <LoadingSpinner
                    className="d-flex align-items-center justify-content-center position-fixed w-100 h-100"
                    style={{ zIndex: 99999, left: 0, top: 0 }} /> : '',
                <div className="px-3 mt-4 mb-5">
                    <div className="row ui-has-modules py-1">
                        <div className="col-12 ui-module mb-0 pb-2 bg-warning">
                            <div className="row mb-2">
                                <div className="col-4 d-flex justify-content-end align-items-center">
                                    <DebounceInput
                                        onKeyPress={e => {
                                            const code = e.keyCode || e.charCode
                                            if (code === 13) { return }
                                            this.setState({ loading: true })
                                        }}
                                        minLength={0}
                                        debounceTimeout={500}
                                        autoComplete="off"
                                        name="searchKeywords"
                                        value={this.state.searchKeywords}
                                        onChange={this.handleSearchChange}
                                        id="searchKeywords"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages["search_placeholder"])}
                                    />
                                </div>
                                <div className="col-3 d-flex justify-content-end align-items-center">
                                    <div className="w-100">
                                        <LabelSelect
                                            placeholder={this.props.intl.formatMessage(messages["label_filter_placeholder"])}
                                            value={this.state.vendorSearchId}
                                            onChange={this.onLabelSelectChange}
                                            type={'vendor'}
                                        />
                                    </div>
                                </div>
                                <div className="col-5 d-flex justify-content-end align-items-center">
                                    <h5 className="mb-1 text-white border-bottom-0 pb-0">
                                        <FormattedMessage
                                            id="purchase_order_lines.listing.order_lines_to_add"
                                            defaultMessage="Order lines to add to PO #{poNumber}"
                                            values={{
                                                poNumber: this.state.purchaseOrderExternalId,
                                            }}
                                        />
                                    </h5>
                                </div>
                            </div>

                        </div>
                    </div>
                    <StandardList
                        smallLine={true}
                        className="row pt-1"
                        tableStyle={{ fontSize: '0.9rem' }}
                        headers={this.state.headers}
                        rows={this.state.rows}
                        footer={this.state.footer}
                        footerClassName={'bg-secondary text-white'}
                        pageSize={this.state.pageSize}
                        totalItemsCount={this.state.totalItemsCount}
                        selectable={true}
                        bulkActions={{
                            'add-order-lines': <span>
                                <Icon value={"dollar-sign"} className={"mr-2"} />
                                <FormattedMessage
                                    id="purchase_order_lines.listing.add_selected_order"
                                    defaultMessage="Add selected order line(s) to PO"
                                />
                            </span>
                        }}
                        customBulkAction={(selection) => {
                            this.addMultipleOrderLinesToPurchaseOrder(this.state.rows.filter(r => selection[r.rowId]).map(r => r.row))
                        }}
                        onSelectAll={(isEverythingSelected, totalItemsCount) => {
                            this.setState({
                                pageSize: isEverythingSelected ? totalItemsCount : 5,
                                selectAllPageSize: isEverythingSelected ? totalItemsCount : 0,
                                activePage: 1,
                            }, () => {
                                this.refreshSearch(true)
                            })
                        }}
                        onPageSelect={(selection) => {
                            const allUnselected = Object.values(selection).filter(isSelected => isSelected).length === 0
                            if (allUnselected) {
                                this.setState({
                                    selectAllPageSize: 0,
                                    pageSize: 5,
                                    activePage: 1,
                                }, () => {
                                    this.refreshSearch(true)
                                })
                            }
                        }}
                    />
                    <Pagination
                        showPageSize={true}
                        onPageSizeChange={this.handlePageSizeChange}
                        activePage={this.state.activePage}
                        pageSize={this.state.pageSize}
                        totalItemsCount={this.state.totalItemsCount}
                        onChange={this.handlePageChange}
                    />
                </div>]
        )
    }
}

export default injectIntl(PurchaseOrderLinesToAddListing)





// WEBPACK FOOTER //
// ./src/order/purchaseorderlinestoadd.listing.component.jsx